var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-alert",
        { attrs: { type: "info", value: _vm.status === "loading" } },
        [_vm._v(_vm._s(_vm.$t("global.loading")))]
      ),
      _c("h1", [_vm._v(_vm._s(_vm.statusTextTitle))]),
      _vm._v(" " + _vm._s(_vm.statusTextContent) + " ")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }